import { render } from "./collections-page.vue?vue&type=template&id=f368b5ee"
const script = {}

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__